import dayjs from 'dayjs';
import 'dayjs/locale/en-gb';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import advancedFormat from 'dayjs/plugin/advancedFormat';

dayjs.extend(localizedFormat);
dayjs.extend(advancedFormat);

export const englishSuffix = (dayOfMonth) => {
  if (dayOfMonth === 1 || dayOfMonth === 21 || dayOfMonth === 31) {
    return 'st';
  }
  if (dayOfMonth === 2 || dayOfMonth === 22) {
    return 'nd';
  }
  if (dayOfMonth === 3 || dayOfMonth === 23) {
    return 'rd';
  }
  return 'th';
};

export const formatDateForCsvExport = (date) => {
  return dayjs(date || undefined).format('YYYY-MM-DD HH:mm:ss');
};

export const formatDateInLocale = (date, countryCode) => {
  const dayjsLocale = countryCode === 'US' ? 'en' : 'en-gb';
  return dayjs(date || undefined)
    .locale(dayjsLocale)
    .format('L LT');
};

export const formatDayAndMonthInLocale = (date, countryCode) => {
  const dayjsLocale = countryCode === 'US' ? 'en' : 'en-gb';
  return dayjs(date || undefined)
    .locale(dayjsLocale)
    .format('Do MMMM');
};

export const dateIsInTheFuture = (date) => {
  return dayjs(date || undefined).isAfter(dayjs());
};

export const dateIsAfter = (a, b) => {
  return dayjs(a || undefined).isAfter(dayjs(b || undefined));
};

export const formatLongDateInLocale = (date, countryCode) => {
  const dayjsLocale = countryCode === 'US' ? 'en' : 'en-gb';
  return dayjs(date || undefined)
    .locale(dayjsLocale)
    .format('dddd LL');
};

/**
 * Interprets jsDate in the browser's local timezone
 * and returns a string in YYYY-MM-DD format
 */
export const calendarDayFromJSDate = (jsDate) => {
  const year = jsDate.getFullYear();
  const month = String(jsDate.getMonth() + 1).padStart(2, '0');
  const day = String(jsDate.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
};
